import type { ConfigQueryKeys } from './types';

/**
 * Query key factory utilities for TanStack Query
 *
 * Convention: [domain, ...identifiers, ...dependencies]
 * All keys must be deterministic and use primitive values only.
 */

export const configQueryKeys: ConfigQueryKeys = {
  advisor: (params) => ['config', 'advisor', params],
  packages: () => ['packages', 'list'],
};
